import React from 'react';
import Constant from '../../Constant';
import FadeInSection from '../FadeInSection';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import { motion } from 'framer-motion';

function Stash() {
    const keyFeatures = [
        {
            icon: <CheckCircleOutlineIcon fontSize="medium" style={{ color: '#8046F2' }} />,
            text: 'Lump-sum deposits',
        },
        {
            icon: <CheckCircleOutlineIcon fontSize="medium" style={{ color: '#8046F2' }} />,
            text: 'Fixed saving period',
        }
    ];

    const idealFor = [
        {
            icon: <AccessibilityIcon fontSize="medium" style={{ color: '#8046F2' }} />,
            text: 'Future milestones',
        },
        {
            icon: <AccessibilityIcon fontSize="medium" style={{ color: '#8046F2' }} />,
            text: 'Preserving and growing untouched funds',
        },
        {
            icon: <AccessibilityIcon fontSize="medium" style={{ color: '#8046F2' }} />,
            text: 'Mid to long-term planning',
        },
    ];

    const container = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: { staggerChildren: 0.2 },
        },
    };

    const item = {
        hidden: { opacity: 0, y: 30 },
        show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
    };

    return (
        <FadeInSection>
            <div className="px-6 sm:px-24 mb-20">
                <h1 className="text-text-color1 font-normal text-[24px] sm:text-[44px] mb-8">
                    Stash <span className={Constant.linearColor}>Savings</span>
                </h1>
                {/* <p className="text-[14px] mb-10 font-normal text-text-color1 sm:text-[20px]"> */}
                <p className="mt-4 text-[14px] mb-10 sm:text-[18px] font-[400] text-text-color1">
                    Put aside a lump sum you don’t want to touch and let it work for you with Stash Savings.
                    Simply deposit your funds, lock them in for a chosen period, and watch your wealth grow the halal way.
                    Perfect for safeguarding money meant for future needs - whether it’s a home purchase, education, or a major life milestone -Stash Savings helps you stay disciplined while ensuring your funds remain ethically invested and interest-free.        </p>

                <div className="grid sm:grid-cols-2 gap-6">
                    <motion.div
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true }}
                        variants={container}
                        className="flex flex-col"
                    >
                        <motion.h2 variants={item} className="text-text-color1 font-normal text-[18px] sm:text-[24px] mb-4">
                            Key Features
                        </motion.h2>
                        <motion.ul variants={container} className="space-y-3">
                            {keyFeatures.map((feature, index) => (
                                <motion.li key={index} variants={item} className="flex items-center gap-3">
                                    <div
                                        className="w-8 h-8 rounded-full flex items-center justify-center"
                                        style={{ backgroundColor: '#F5F1FE' }}
                                    >
                                        {feature.icon}
                                    </div>
                                    <span className="text-[14px] sm:text-[16px] font-[400] text-text-color1">
                                        {feature.text}
                                    </span>
                                </motion.li>
                            ))}
                        </motion.ul>
                    </motion.div>

                    <motion.div
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true }}
                        variants={container}
                        className="flex flex-col"
                    >
                        <motion.h2 variants={item} className="text-text-color1 font-normal text-[18px] sm:text-[24px] mb-4">
                            Ideal For
                        </motion.h2>
                        <motion.ul variants={container} className="space-y-3">
                            {idealFor.map((item, index) => (
                                <motion.li key={index} variants={item} className="flex items-center gap-3">
                                    <div
                                        className="w-8 h-8 rounded-full flex items-center justify-center"
                                        style={{ backgroundColor: '#F5F1FE' }}
                                    >
                                        {item.icon}
                                    </div>
                                    <span className="text-[14px] sm:text-[16px] font-[400] text-text-color1">
                                        {item.text}
                                    </span>
                                </motion.li>
                            ))}
                        </motion.ul>
                    </motion.div>
                </div>
            </div>
        </FadeInSection>
    );
}

export default Stash;